"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AliasTransaction = void 0;

var UInt64_1 = require("../UInt64");

var AddressAliasTransaction_1 = require("./AddressAliasTransaction");

var MosaicAliasTransaction_1 = require("./MosaicAliasTransaction");

var Transaction_1 = require("./Transaction");

var AliasTransaction = /*#__PURE__*/function (_Transaction_1$Transa) {
  _inherits(AliasTransaction, _Transaction_1$Transa);

  var _super = _createSuper(AliasTransaction);

  function AliasTransaction() {
    _classCallCheck(this, AliasTransaction);

    return _super.apply(this, arguments);
  }

  _createClass(AliasTransaction, null, [{
    key: "createForAddress",
    value:
    /**
     * Create an address alias transaction object
     * @param deadline - The deadline to include the transaction.
     * @param aliasAction - The namespace id.
     * @param namespaceId - The namespace id.
     * @param address - The address.
     * @param networkType - The network type.
     * @param maxFee - (Optional) Max fee defined by the sender
     * @param signature - (Optional) Transaction signature
     * @param signer - (Optional) Signer public account
     * @returns {AddressAliasTransaction}
     */
    function createForAddress(deadline, aliasAction, namespaceId, address, networkType) {
      var maxFee = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new UInt64_1.UInt64([0, 0]);
      var signature = arguments.length > 6 ? arguments[6] : undefined;
      var signer = arguments.length > 7 ? arguments[7] : undefined;
      return AddressAliasTransaction_1.AddressAliasTransaction.create(deadline, aliasAction, namespaceId, address, networkType, maxFee, signature, signer);
    }
    /**
     * Create a mosaic alias transaction object
     * @param deadline - The deadline to include the transaction.
     * @param aliasAction - The namespace id.
     * @param namespaceId - The namespace id.
     * @param mosaicId - The mosaic id.
     * @param networkType - The network type.
     * @param maxFee - (Optional) Max fee defined by the sender
     * @param signature - (Optional) Transaction signature
     * @param signer - (Optional) Signer public account
     * @returns {MosaicAliasTransaction}
     */

  }, {
    key: "createForMosaic",
    value: function createForMosaic(deadline, aliasAction, namespaceId, mosaicId, networkType) {
      var maxFee = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new UInt64_1.UInt64([0, 0]);
      var signature = arguments.length > 6 ? arguments[6] : undefined;
      var signer = arguments.length > 7 ? arguments[7] : undefined;
      return MosaicAliasTransaction_1.MosaicAliasTransaction.create(deadline, aliasAction, namespaceId, mosaicId, networkType, maxFee, signature, signer);
    }
  }]);

  return AliasTransaction;
}(Transaction_1.Transaction);

exports.AliasTransaction = AliasTransaction;